import { render, staticRenderFns } from "./AccessRight.vue?vue&type=template&id=dc2cbc2c"
import script from "./AccessRight.vue?vue&type=script&lang=js"
export * from "./AccessRight.vue?vue&type=script&lang=js"
import style0 from "./AccessRight.vue?vue&type=style&index=0&id=dc2cbc2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports